import React from 'react';
import '../utils/QuienesSomos.css';
import { FaTachometerAlt, FaFileContract, FaUserShield } from 'react-icons/fa';

const QuienesSomos = () => {
  return (
    <div className="aboutus-container">
      <main className="aboutus-main">
        <div className="aboutus-grid">
          <section className="aboutus-section">
            <h2>
              <FaTachometerAlt className="icon-title" />
              ¡Bienvenidos al Sistema de Gestión de Cobros y Medición de Agua Potable!
            </h2>
            <p>
              Nuestra Plataforma está diseñada para facilitar y optimizar la administración y cobro de tarifas por el suministro de agua. Con el crecimiento del número de socios, desarrollamos una solución integral para manejar todos los aspectos de facturación y gestión de medidores.
            </p>
            <p>
              Los usuarios reciben un comprobante de pago detallado con información sobre el medidor, consumo y cargos. La plataforma registra pagos, moras y reconexiones, facilitando el trabajo del personal encargado.
            </p>
            <p>
              Buscamos eficiencia y transparencia en la gestión del agua. Si necesitas ayuda, contáctanos. Estamos aquí para ayudarte a mantener un servicio eficaz y bien gestionado.
            </p>
          </section>

          <section className="aboutus-section">
            <h2>
              <FaFileContract className="icon-title" />
              Términos y Condiciones
            </h2>
            <p>Al usar nuestra plataforma, aceptas lo siguiente:</p>
            <ul>
              <li><strong>Uso del Servicio:</strong> Solo para administración y cobro de agua. Prohibido su uso indebido.</li>
              <li><strong>Propiedad Intelectual:</strong> Contenidos y tecnologías están protegidos legalmente.</li>
              <li><strong>Responsabilidad:</strong> No somos responsables por daños por mal uso. Los usuarios deben cumplir las normas.</li>
            </ul>
          </section>

          <section className="aboutus-section">
            <h2>
              <FaUserShield className="icon-title" />
              Políticas de Privacidad
            </h2>
            <p>Valoramos tu privacidad. Así gestionamos tu información:</p>
            <ul>
              <li><strong>Recopilación:</strong> Datos personales y de uso para gestión y mejoras.</li>
              <li><strong>Uso:</strong> Para tarifas, comprobantes y eficiencia del sistema.</li>
              <li><strong>Protección:</strong> Medidas de seguridad contra accesos no autorizados.</li>
            </ul>
            <p>Para más detalles, contáctanos.</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default QuienesSomos;
